export const LICENCE_STATUSES = [
  { value: 'pending', label: 'Εκκρεμεί' },
  { value: 'active', label: 'Ενεργό' },
  { value: 'suspended', label: 'Σε αναστολή' },
  { value: 'expired', label: 'Ληγμένο' },
  { value: 'cancelled', label: 'Ακυρωμένο' },
];

const STATUS_COLORS = {
  pending: 'warning',
  active: 'success',
  suspended: 'warning',
  expired: 'error',
  cancelled: 'default',
};

export function statusLabel(status) {
  return LICENCE_STATUSES.find((option) => option.value === status)?.label || status;
}

export function statusColor(status) {
  return STATUS_COLORS[status] || 'default';
}

const DURATION_LABELS = {
  1: 'Μηνιαίο',
  3: 'Τριμηνιαίο',
  6: 'Εξάμηνο',
  12: 'Ετήσιο',
  24: 'Διετές',
  36: 'Τριετές',
};

export function formatPlanRange(durationMonths) {
  if (!durationMonths) return 'Απεριόριστο';
  const months = Number(durationMonths);
  return DURATION_LABELS[months] || `${months} μήνες`;
}

export function formatDate(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleDateString('el-GR');
}

export function formatDateTime(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleString('el-GR', { dateStyle: 'short', timeStyle: 'short' });
}
